module.exports = __webpack_public_path__ + "static/media/new_product1.4809dfdc.png";